// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PremiumPlanStore, for use in the registry */ export const PremiumPlanStoreActionTypes = [
    ActionType.CreatePremiumPlanAction,
    ActionType.CreatePremiumPlanFailedAction,
    ActionType.CreatePremiumPlanSucceededAction,
    ActionType.FetchPremiumPlanItemsSharedWithUserAction,
    ActionType.FetchPremiumPlanItemsSharedWithUserSucceededAction,
    ActionType.FetchPremiumPlanItemsSharedWithUserFailedAction,
    ActionType.FetchPremiumPlanItemsCreatedByUserAction,
    ActionType.FetchPremiumPlanItemsCreatedByUserSucceededAction,
    ActionType.FetchPremiumPlanItemsCreatedByUserFailedAction,
    ActionType.FetchPremiumPlanItemsSharedWithGroupAction,
    ActionType.FetchPremiumPlanItemsSharedWithGroupSucceededAction,
    ActionType.FetchPremiumPlanItemsSharedWithGroupFailedAction,
    ActionType.OpenPremiumPlanAction,
    ActionType.OpenPremiumPlanSucceededAction,
    ActionType.OpenPremiumPlanFailedAction,
    ActionType.PremiumPlanOptimisticProcessingCompleteAction,
    ActionType.PremiumPlanPropertyUpdateCompleteAction,
    ActionType.UpdatePremiumPlanAction,
    ActionType.UpdatePremiumPlanSucceededAction,
    ActionType.UpdatePremiumPlanFailedAction,
    ActionType.ConvertPlanToPremiumSucceededAction,
    ActionType.SetPlanFilterAction
];
